import styled from "styled-components"

export const StyledContainer = styled.div`
  
  width:fit-content;
  max-width:100%;
  margin:0 auto;


  
`